(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["auratiq-hero-banners"] && !Shopify.designMode) return;
  try {
    
  class HeroBanners extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-track]');
      this.slides = this.querySelectorAll('.aqhb__slide');
      this.dots = this.querySelectorAll('.aqhb__dot');
      this.index = 0;
      this.count = this.slides.length;
      if (this.count <= 1) return;
      const next = this.querySelector('.aqhb__arrow--next');
      const prev = this.querySelector('.aqhb__arrow--prev');
      if (next) next.addEventListener('click', () => this.go(this.index + 1, true));
      if (prev) prev.addEventListener('click', () => this.go(this.index - 1, true));
      this.dots.forEach((dot) => dot.addEventListener('click', () => this.go(parseInt(dot.dataset.i, 10), true)));
      this.addEventListener('mouseenter', () => clearInterval(this.timer));
      this.addEventListener('mouseleave', () => this.start());
      this.start();
    }
    go(target, manual) {
      this.index = (target + this.count) % this.count;
      this.track.style.transform = 'translateX(-' + (this.index * 100) + '%)';
      this.dots.forEach((dot, i) => dot.classList.toggle('is-active', i === this.index));
      if (manual) this.start();
    }
    start() {
      clearInterval(this.timer);
      if (this.dataset.autoplay === 'true' && this.count > 1) {
        this.timer = setInterval(() => this.go(this.index + 1), parseInt(this.dataset.speed, 10) || 5000);
      }
    }
    disconnectedCallback() { clearInterval(this.timer); }
  }
  if (!customElements.get('hero-banners')) customElements.define('hero-banners', HeroBanners);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
